import authFooterBackground from "../assets/images/auth-footer-background.png";
import authStyleCorrect from "../assets/images/auth-style-correct.png";
import authStyleWrong from "../assets/images/auth-style-wrong.png";
import benefit1 from "../assets/images/benefit-1.png";
import benefit2 from "../assets/images/benefit-2.png";
import bronzeRank from "../assets/images/bronze-rank.png";
import contactUsBackground from "../assets/images/contact-us-background.png";
import diamondRank from "../assets/images/diamond-rank.png";
import eighteenCaratGold from "../assets/images/18-carat-gold.png";
import friends from "../assets/images/friends.png";
import goldenRank from "../assets/images/golden-rank.png";
import goldSafe from "../assets/images/gold-safe.png";
import halfCoin from "../assets/images/half-coin.png";
import imamiCoin from "../assets/images/imami-coin.png";
import inviteFriends from "../assets/images/invite-friends.png";
import meltedGold from "../assets/images/melted-gold.png";
import moneySack from "../assets/images/money-sack.png";
import priceBoxBackground from "../assets/images/price-box-background.png";
import productBackground from "../assets/images/product-background.png";
import silverRank from "../assets/images/silver-rank.png";
import siteLogo from "../assets/images/site-logo.png";
import uploadPhotoBackground from "../assets/images/upload-photo-background.png";
import userDropdownArrowhead from "../assets/images/user-dropdown-arrowhead.png";

const images = {
  authFooterBackground,
  authStyleCorrect,
  authStyleWrong,
  benefit1,
  benefit2,
  bronzeRank,
  contactUsBackground,
  diamondRank,
  eighteenCaratGold,
  friends,
  goldenRank,
  goldSafe,
  halfCoin,
  imamiCoin,
  inviteFriends,
  meltedGold,
  moneySack,
  priceBoxBackground,
  productBackground,
  silverRank,
  siteLogo,
  uploadPhotoBackground,
  userDropdownArrowhead,
};

export default images;
